import {
  CreateSecretaryPayload,
  UpdateSecretaryPayload,
} from "../types/secretary.definition";
import { resendTemporaryPassword } from "../webclients/manager.client";
import {
  assignSecretaryToFacility,
  createSecretary,
  deleteSecretary,
  getAllFacilitySecretaries,
  getSecretaryById,
  unassignSecretaryFromFacility,
  updateSecretary,
} from "../webclients/secretary.client";

export const secretaryApi = {
  getSecretaryById: async (secretaryId: string) => {
    const response = await getSecretaryById(secretaryId);
    return response.data;
  },
  updateSecretary: async (
    secretaryId: string,
    data: Partial<UpdateSecretaryPayload>
  ) => {
    const response = await updateSecretary(secretaryId, data);
    return response.data;
  },
  getAllFacilitySecretaries: async (facilityId: string) => {
    const response = await getAllFacilitySecretaries(facilityId);
    return response.data;
  },
  createSecretary: async (data: CreateSecretaryPayload) => {
    const response = await createSecretary(data);
    return response.data;
  },
  deleteSecretary: async (secretaryId: string) => {
    const response = await deleteSecretary(secretaryId);
    return response.data;
  },
  assignToFacility: async (
    facilityId: string | number,
    secretaryId: string | number
  ): Promise<void> => {
    await assignSecretaryToFacility(secretaryId, facilityId);
  },
  unassignFromFacility: async (
    facilityId: string | number,
    secretaryId: string | number
  ): Promise<void> => {
    await unassignSecretaryFromFacility(secretaryId, facilityId);
  },
  // Resend temporary password
  resendTemporaryPassword: async (userId: string): Promise<void> => {
    await resendTemporaryPassword(userId);
  },
};

export default secretaryApi;
